import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#tree" }),
    /*#__PURE__*/_createTextVNode(" Tree ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Display a set of data with hierarchies. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUISelectable = _resolveComponent("EUISelectable")
  const _component_EUICustomLeafNodeInLazyMode = _resolveComponent("EUICustomLeafNodeInLazyMode")
  const _component_EUIDisabledCheckbox = _resolveComponent("EUIDisabledCheckbox")
  const _component_EUIDefaultExpandedAndDefaultChecked = _resolveComponent("EUIDefaultExpandedAndDefaultChecked")
  const _component_EUICheckingTreeNodes = _resolveComponent("EUICheckingTreeNodes")
  const _component_EUICustomNodeContent = _resolveComponent("EUICustomNodeContent")
  const _component_EUITreeNodeFiltering = _resolveComponent("EUITreeNodeFiltering")
  const _component_EUIAccordion = _resolveComponent("EUIAccordion")
  const _component_EUIDraggable = _resolveComponent("EUIDraggable")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUISelectable),
    _createVNode(_component_EUICustomLeafNodeInLazyMode),
    _createVNode(_component_EUIDisabledCheckbox),
    _createVNode(_component_EUIDefaultExpandedAndDefaultChecked),
    _createVNode(_component_EUICheckingTreeNodes),
    _createVNode(_component_EUICustomNodeContent),
    _createVNode(_component_EUITreeNodeFiltering),
    _createVNode(_component_EUIAccordion),
    _createVNode(_component_EUIDraggable)
  ], 64))
}